import React from 'react';
import classNames from 'classnames';
import Icon from 'components/icon';

import styles from './styles.scss';

const FlashMessage = ({
	onClick = () => null,
	children,
	title = '',
	body = '',
	info = false,
	success = false,
	error = false,
	warning = false,
	closeButton = false,
}) => {
	const flashStyles = classNames([
		'flash-message',
		info && 'flash-message--info',
		success && 'flash-message--success',
		error && 'flash-message--error',
		warning && 'flash-message--warning',
		!closeButton && 'flash-message--click-to-close',
	]);

	const MsgIcon = () => {
		switch (true) {
			case info:
				return <Icon type='fi' name='FiAlertCircle' />;
			case success:
				return <Icon type='fi' name='FiCheck' />;
			case error:
				return <Icon type='fi' name='FiX' />;
			case warning:
				return <Icon type='fi' name='FiAlertTriangle' />;
			default:
				return null;
		}
	};

	/* Determines whether onClick is put on the entire flash message or just the close cross */
	const flashOnClick = closeButton ? null : onClick;

	return (
		<div className={flashStyles} onClick={flashOnClick} role='alert'>
			<div className={'flash-element'}>
                <MsgIcon />
			</div>
			<div className={'flash-element'}>
				{title && <h4 className={'flash-message-title'}>{title}</h4>}
				{body && <p className={'flash-message-body'}>{body}</p>}
				{children}
			</div>
			{closeButton /* Only displays if closeButton is chosen */ && (
				<div className={'close'}>
					<p onClick={onClick}>&#10005;</p>
				</div>
			)}
		</div>
	);
};

export default FlashMessage;
